export const formatMoney = (value) => {
  if (!value) return ''
  return (parseFloat(value) / 100.0).toFixed(2)
}

export const dollarsToCents = (amount) =>
  Math.round(
    100 *
      parseFloat(
        typeof amount === 'string'
          ? amount.replace(/[$,]/g, '')
          : amount
      )
  )
